<template>
<div class="chapter">
<div class="inner_page">
<p class="p13"><span class="sz"><b>From The Desk of Jeanne Glidewell</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p18"><span class="sz">Dear Reader,</span></p>
<p class="p19"><span class="sz">I have a habit of apologizing in advance when presenting someone with a gift, having convinced myself they are going to hate it. In this same vein, I'd like to apologize up front if you find yourself horrified by my use of bordering-on-absurd grammar that goes against the grain of what your fifth-grade English teacher taught you, or when I invoke my creative license to employ a word that somehow got overlooked by every dictionary ever compiled, abridged or not. I am blessed with two incredible editors, but one cannot expect these ladies to turn water into wine. Only God can perform miracles, and clearly he has more important issues to take care of.</span></p>
<p class="p14"><span class="sz">You may also think the idea of a sixty-eight-year-old amateur sleuth doing risky or impetuous things in her efforts to track down a killer is a far-fetched notion. But if you do, isn't that the very premise of the entire "cozy mystery" genre?</span></p>
<p class="p14"><span class="sz">So, if these things disturb you, my mysteries are not for you. My objective is to entertain you on those occasions when you need something to while away your time; as you sit squeezed into an airplane seat for the duration of a long-distance flight; while you're sprawled out on a beach chair, soaking up the sun with your e-reader in one hand and a margarita in the other; or when you just want to relax, all snuggled up in your recliner in front of a roaring fire with your favorite furry friend curled up in your lap. If you find yourself in one of these situations and are not offended by the work of an author who chose archery and racquet ball classes in college in lieu of English and grammar whenever possible, then sit back, kick off your shoes, and let me tell you a story.</span></p>
<p class="p20"><span class="sz">Happy Reading,</span></p>
<p class="p1"><span class="sz"><i>Jeannie</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section7.vue?22e8c97f